
import { Component, Vue, Watch } from "vue-property-decorator";
import lsPagination from "@/components/ls-pagination.vue";
import LsDialog from "@/components/ls-dialog.vue";
import { RequestPaging } from "@/utils/util";
import PopoverInput from "@/components/popover-input.vue";
import { apiShopModelList, apiShopLists } from "@/api/shop.ts";
@Component({
  components: {
    lsPagination,
    LsDialog,
    PopoverInput,
  },
})
export default class ShopModelList extends Vue {
  $refs!: { shopTable: any; rangeRef: any; searchFormRef: any; userTable: any };
  /** S Data **/

  pager: RequestPaging = new RequestPaging();

  searchObj: any = {
    sid: "",
    id: "",
    zh_cn_title: "",
    cate_id: "",
    code: "",
    model_code: "",
    status: "",
    share_way: "",
    market_status: -10,
    sort_field: "",
  };

  shop_lists: any[] = [];

  apiShopModelList = apiShopModelList;
  // 1=内测,2=禁用,3=启用
  statusList = [
    { label: "上架", value: 1 },
    { label: "下架", value: 0 },
  ];
  marketStatusList = [
    { label: "全部", value: -10 },
    { label: "未上架", value: 0 },
    { label: "已上架", value: 1 },
    { label: "审核中", value: -1 },
    { label: "已拒绝", value: -2 },
  ];

  /** E Data **/

  /** E Data **/
  getShopList() {
    apiShopLists({ page_size: 9999 }).then((res) => {
      this.shop_lists = res.lists;
    });
  }

  getList(page?: number) {
    page && (this.pager.page = page);
    console.log(
      "🚀 ~ ShopModelList ~ getList ~ his.pager.page:",
      this.pager.page,
    );
    this.pager.request({
      callback: apiShopModelList,
      params: {
        ...this.searchObj,
      },
    });
  }

  handleEdit(id: string) {
    this.$router.push({
      path: "/shop/model_edit",
      query: {
        id: id,
        mode: "edit",
        page_no: this.pager.page as any,
        preSearchObj: this.searchObj,
      },
    });
  }

  // 重置搜索
  reset(): void {
    this.$refs.searchFormRef.resetFields();
    this.getList(1);
  }

  /** E Methods **/
  /** S ods **/
  created() {
    this.getShopList();
    this.getList(1);
  }
  /** E Methods **/
}
